import styled from 'styled-components/macro';

import { colors } from '../../styles/vars';

const Position = styled.input`
  width: 30px;
  height: 30px;
  background-color: ${(props) => props.isValid ? '#1a1616' : colors['dusty-orange']};
  opacity: ${(props) => props.isActive ? 1 : '0.6'};
  font-size: 14px;
  border-style: none;
  color: #fff;
  text-align: center;
  transition: background-color 0.1s ease-out;
`;

export default Position;
